<template>
  <v-form onsubmit="return false;" ref="metadataForm">
    <v-layout row wrap>
      <v-flex xs6 class="pa-2 pr-5">
        <!-- Subtitle languages -->
        <v-autocomplete
          v-model="film.subtitle_languages"
          :items="DEFINES.COUNTRY_LANGUAGES"
          :label="$t('screener.film.subtitle_language.title')"
          item-text="name"
          item-value="code"
          multiple
          @input="resetAutocomplete"
          :search-input.sync="subtitleLangSearchInput"
          color="primary"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 class="pa-2 pl-5">
        <!-- Media languages -->
        <v-autocomplete
          v-model="film.film_languages"
          :items="DEFINES.COUNTRY_LANGUAGES"
          :label="$t('screener.film.media_language.title')"
          item-text="name"
          item-value="code"
          multiple
          @input="resetAutocomplete"
          :search-input.sync="filmLangSearchInput"
          color="primary"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 class="pa-2 pr-5">
        <!-- Released year -->
        <v-text-field
          v-model="film.released_year"
          :label="$t('screener.film.released_year.title')"
          type="number"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 class="pa-2 pl-5">
        <!-- Imbdb URL/ID -->
        <v-text-field
          v-model="film.imdb_ref"
          color="primary"
          :label="$t('screener.film.imdb_url')"
          type="text"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 class="pa-2 pr-5">
        <!-- Country -->
        <v-autocomplete
          v-model="film.countries"
          :items="countries"
          :label="$t('screener.film.country.title')"
          item-text="name"
          item-value="iso_3166_2"
          multiple
          @input="resetAutocomplete"
          :search-input.sync="countrySearchInput"
          color="primary"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 class="pa-2 pl-5">
        <!-- Sales Agent -->
        <v-text-field
          v-model="film.sales_agent"
          :label="$t('screener.film.sales_agent.title')"
          color="primary"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 class="pa-2 pr-5">
        <!-- Genre -->
        <v-text-field
          v-model="film.genre"
          :label="$t('screener.film.genre.title')"
          color="primary"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 class="pa-2 pl-5">
        <!-- Script Writer -->
        <v-text-field
          v-model="film.script_writer"
          :label="$t('screener.film.scripting.title')"
          color="primary"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 class="pa-2 pr-5">
        <!-- Cinematography -->
        <v-text-field
          v-model="film.cinematography"
          :label="$t('screener.film.cinematography.title')"
          color="primary"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 class="pa-2 pl-5">
        <!-- Film Editing -->
        <v-text-field
          v-model="film.editing"
          :label="$t('screener.film.editing.title')"
          color="primary"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 class="pa-2 pr-5">
        <!-- Music -->
        <v-text-field
          v-model="film.music"
          :label="$t('screener.film.music.title')"
          color="primary"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 class="pa-2 pl-5">
        <!-- Cast -->
        <v-text-field
          v-model="film.cast"
          :label="$t('screener.film.cast.title')"
          color="primary"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 class="pa-2 pr-5">
        <!-- Backing -->
        <v-text-field
          v-model="film.backing"
          :label="$t('screener.film.backing.title')"
          color="primary"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import rules from "@/validation";
import { mapState } from "vuex";

export default {
  name: "MediaMetadataForm",
  props: {
    film: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      rules,
      subtitleLangSearchInput: null,
      filmLangSearchInput: null,
      countrySearchInput: null,
    };
  },
  computed: {
    ...mapState({
      countries: (state) => state.country.list,
    }),
  },
  watch: {
    film: {
      deep: true,
      handler: function () {
        this.$emit("update:film", this.film);
      },
    },
  },
  mounted() {
    this.getCountries();
  },
  methods: {
    resetAutocomplete(){
      setTimeout(() => {
        this.countrySearchInput = null;
        this.subtitleLangSearchInput = null;
        this.filmLangSearchInput = null;
        }, 2000);
    },

    validate() {
      return this.$refs.metadataForm.validate();
    },
    async getCountries() {
      try {
        return await this.$store.dispatch("country/list");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
  },
};
</script>

<style>
</style>
